"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isOrphan = exports.hasAncestor = void 0;
var hasAncestor = function hasAncestor(target, ancestor) {
  return !!target && !!ancestor && ancestor.contains(target);
};
exports.hasAncestor = hasAncestor;
var isOrphan = function isOrphan(target) {
  return typeof document === 'undefined' || !document.documentElement.contains(target);
};
exports.isOrphan = isOrphan;